// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// /Users/m802941/.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es7.system.global.js
// module id = 357
// module chunks = 9